export default __webpack_public_path__ + "static/media/sort-up.58f4424e.svg";